import { Component, OnInit, ViewChild } from '@angular/core';
import { GeolocationService } from '../services/geolocation.service';
import { } from '@types/googlemaps';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { PuntoVisita } from '../Models/PuntoVisita';
import { PuntoVisitaLocalizacion } from '../Models/PuntoVisitaLocalizacion';

import { PuntoVisitaService } from '../services/punto-visita.service';
import { GlobalsService } from '../services/globals.service';
import { PARAMETERS } from '@angular/core/src/util/decorators';

@Component({
  selector: 'app-actualizar-punto-visita',
  templateUrl: './actualizar-punto-visita.component.html',
  styleUrls: ['./actualizar-punto-visita.component.css']
})
export class ActualizarPuntoVisitaComponent implements OnInit {


  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;

  public punto: PuntoVisita = new PuntoVisita();
  public puntos: PuntoVisita[];

  public puntoLocalizacion: PuntoVisitaLocalizacion = new PuntoVisitaLocalizacion();
  public puntoLocalizaciones: PuntoVisitaLocalizacion[];

  public mostrarMapa: boolean = false;
  public modoEdicion: boolean = false;

  public markers = [];


  columnDefs = [
    { headerName: 'Nombre', field: 'nombrePunto', icons: { filter: ' ' } },
    { headerName: 'Fecha', field: 'fecha', icons: { filter: ' ' } },
    { headerName: 'Longitud', field: 'longitud', icons: { filter: ' ' } },
    { headerName: 'Latitud', field: 'latitud', icons: { filter: ' ' } },

  ];

  rowData: any[];


  constructor(
    private geoService: GeolocationService,
    private puntoVisitaService: PuntoVisitaService,
    private globalServices: GlobalsService
  ) { }

  ngOnInit() {
    this.CargarPuntosLocalizacion();
  }


  // carga la lista de localizaciones
  CargarPuntosLocalizacion() {
    try {

      this.puntoVisitaService.ObtenerPuntoVisitasLocalizacion(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.puntoLocalizaciones = data;

          this.rowData = this.puntoLocalizaciones;


        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarPuntosLocalizacion: " + error);
    }

  }

  //cuando le da click en un row
  
  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    //Se debe clonar el item para que no afecte el array origen en memoria
    this.modoEdicion = true;

    this.puntoLocalizacion = datos;
    this.obtenerPuntoVisita();

  }

  cagarMapa() {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: {
        lat: parseFloat(this.puntoLocalizacion.latitud),
        lng: parseFloat(this.puntoLocalizacion.longitud)
      },
      zoom: 15
    });

  }

  dibujarMapa(latitud: string, longitud: string, nombrePunto: string, tipo: string) {
    try {

      if (tipo === "viejo") {
        var contenido = "<div> <h1>Punto de visita: " + nombrePunto + "</h1>  <br> <h2>Punto de visita original  </h2></div>";
      }
      else {
        var contenido = "<div> <h1>Punto de visita: " + nombrePunto + "</h1>  <br> <h2>Punto de visita actualizado por el transportista  </h2></div>";
      }

      var marker = new google.maps.Marker({

        position: { lat: parseFloat(latitud), lng: parseFloat(longitud) },
        map: this.map,
        title: "",

      }),
        infowindow = new google.maps.InfoWindow({
          content: contenido
        });

      google.maps.event.addListener(marker, 'click', function () {

        infowindow.open(this.map, marker);

      });

      this.markers.push(marker);



    } catch (error) {

    }
  }

  obtenerPuntoVisita() {
    try {

      this.puntoVisitaService.ObtenerPuntoVisita(this.globalServices.ObtenerCompania(), this.puntoLocalizacion.idPunto).subscribe(
        data => {
          this.punto = data;


          this.cagarMapa();
          this.dibujarMapa(this.punto.latitud, this.punto.longitud, this.punto.nombrePunto, "viejo");
          this.dibujarMapa(this.puntoLocalizacion.latitud, this.puntoLocalizacion.longitud, this.puntoLocalizacion.nombrePunto, "nuevo");
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("obtenerPuntoVisita: " + error);
    }

  }


  ActualizarPunto() {

    this.puntoVisitaService.ActualializarPuntoVisitaLocalidad(this.puntoLocalizacion.id).subscribe(
      data => {

        swal("Registro guardado con éxito!", "", "success");

        this.punto = new PuntoVisita();
        this.modoEdicion = false;
        this.CargarPuntosLocalizacion();


      },
      err => {
        console.error(err);
        swal("Error al registrar!", "", "error");
      }

    );

  }


  DenegarPunto() {

    this.puntoVisitaService.DenegarPuntoVisitaLocalidad(this.puntoLocalizacion.id).subscribe(
      data => {

        swal("Registro guardado con éxito!", "", "success");

        this.punto = new PuntoVisita();
        this.modoEdicion = false;
        this.CargarPuntosLocalizacion();


      },
      err => {
        console.error(err);
        swal("Error al registrar!", "", "error");
      }

    );

  }


  CancelarPunto() {

    this.modoEdicion = false;
  }

}
